import { JsxStyleProps } from '@chakra-ui/react';
import * as React from 'react';
import { Box, BoxProps } from './Box';

export interface FlexProps extends BoxProps {
  height?: JsxStyleProps['height'];
  width?: JsxStyleProps['width'];
  gap?: JsxStyleProps['gap'];
  rowGap?: JsxStyleProps['rowGap'];
  columnGap?: JsxStyleProps['columnGap'];
  alignItems?: JsxStyleProps['alignItems'];
  alignContent?: JsxStyleProps['alignContent'];
  justifyItems?: JsxStyleProps['justifyItems'];
  justifyContent?: JsxStyleProps['justifyContent'];
  flexWrap?: JsxStyleProps['flexWrap'];
  flexDirection?: JsxStyleProps['flexDirection'];
  justifySelf?: JsxStyleProps['justifySelf'];
  alignSelf?: JsxStyleProps['alignSelf'];
  order?: JsxStyleProps['order'];
}

type Props = React.ComponentProps<'div'> &
  FlexProps &
  BoxProps & {
    children?: React.ReactNode;
    className?: string;
  };

export const Flex = React.forwardRef<HTMLDivElement, Props>(function Flex(props, ref) {
  return React.createElement(Box, { ref, ...props, chakracss: { display: 'flex' } });
});

export const FlexCentered = React.forwardRef<HTMLDivElement, Props>(function FlexCentered(props, ref) {
  return React.createElement(Flex, {
    ref,
    ...props,
    justifyContent: 'center',
    alignItems: 'center',
  });
});
